import { proxyHost } from "@pro/common/utils/proxyInfo";
import i18n from "../i18n/i18n";

const getOneHikIdUrl = () => {
  // 开发环境下源为本地代理的地址
  const origin = process.env.mode === 'dev' ? proxyHost : window.location.origin;
  if (origin === 'https://ius.hik-partner.com') {
    // 北美PE
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://isa.hik-partner.com') {
    // 南美PE
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://isgp.hik-partner.com') {
    // 新加坡PE
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://ieu.hik-partner.com') {
    // 欧洲PE
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://www.hik-partner.com') {
    // 欧洲PE
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://hik-partnerru.com') {
    // 俄罗斯
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://www.hik-partnerru.com') {
    // 俄罗斯www
    return 'https://cloudsso.hikvision.com/';
  }
  if (origin === 'https://iind.hik-partner.com') {
    // 印度
    return 'https://cloudsso.hikvision.com/';
  }
  // 使用正则匹配域名跳转地址，若要修改，只需要增加数字部分对应的UAT环境
  if ((/https:\/\/hpc-sgp-uat-(7|8|9|13|14)(-inner)?(-v\d+)?\.(hik-proconnect|hik-partner)\.com\/?/).test(origin)) {
    return 'https://identity-uat.hikvision.com/';
  }
  if ((/https:\/\/hpc-sgp-uat-(3|6)(-inner)?(-v\d+)?\.(hik-proconnect|hik-partner)\.com\/?/).test(origin)) {
    return 'https://identity-dev.hikvision.com/';
  }
  return 'https://identity-test.hikvision.com/';
};

export const getEPAgentServiceUrl = (link = 'https://iservice.hikvision.com/chat/HIKVISION/1934905360690626562/1934901701537366017') => {
  if (link === true || !link) {
    link = 'https://iservice.hikvision.com/chat/HIKVISION/1934905360690626562/1934901701537366017';
  }
  const origin = process.env.mode === 'dev' ? proxyHost : window.location.origin;
  let region;
  if (origin === 'https://ius.hik-partner.com') {
    // 北美PE
    region = 'US';
  }
  if (origin === 'https://isa.hik-partner.com') {
    // 南美PE
    region = 'SA';
  }
  if (origin === 'https://isgp.hik-partner.com') {
    // 新加坡PE
    region = 'SGP';
  }
  if (origin === 'https://ieu.hik-partner.com') {
    // 欧洲PE
    region = 'EU';
  }
  if (origin === 'https://www.hik-partner.com') {
    // 欧洲PE
    region = 'EU';
  }
  if (origin === 'https://hik-partnerru.com') {
    // 俄罗斯
    region = 'RU';
  }
  if (origin === 'https://www.hik-partnerru.com') {
    // 俄罗斯www
    region = 'RU';
  }
  if (origin === 'https://iind.hik-partner.com') {
    // 印度
    region = 'INDIA';
  }
  const oneHikidURL = getOneHikIdUrl();
  let locale = i18n.locale;
  console.log(i18n.locale, 'i18n.locale');
  if (i18n.locale === 'zh_TW') {
    locale = 'zhHant';
  } else if (i18n.locale === 'in') {
    locale = 'id';
  }
  if (oneHikidURL === 'https://cloudsso.hikvision.com/') {
    return `${link}?region=${region}&Lan=${locale}&appid=2`;
  }
  return link ? `${link}?region=SGP&Lan=${locale}&appid=2` : `https://iservice-uat.hikvision.com/chat/HIKVISION/1928087607633350658/1928080645956931586?region=SGP&Lan=${locale}&appid=2`;
};

export default getOneHikIdUrl;
